import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class BulkMessageService {

  constructor(private http: HttpClient,
    private dataService: DataService) { }

  bulkMessage(groupMessages: string) {
    return this.dataService.post('/api/bulk/BulkMessageSend', groupMessages)
  }

  pushbulkMessage(groupMessages: string) {
    return this.dataService.post('/api/bulk/PushBulkMessageSend', groupMessages)
  }

  singleMessage(singleMessages: string) {
    return this.dataService.post('/api/bulk/SingleMessageSend', singleMessages);
  }

  pushsingleMessage(singleMessages: string) {
    return this.dataService.post('/api/bulk/PushNotificationSingleMessage', singleMessages);
  }

  getTemplateContent(templateId: number) {
    return this.dataService.getRecord('/api/bulk/getTemplateContent/' + templateId);
  }
  //getTemplateContent (templateId) {
  //    return this.dataService.getRecord('/api/bulk/getTemplateContent/' + templateId);
  //}
  getMessagingUserDetailsBySPIdandCity(searchQuery: string) {
    return this.dataService.getRecordWithParams('/api/bulk/getMessagingUserDetailsBySPIdandCity', searchQuery);
  }
  getUserDetailsBySPIdandCity(searchQuery: string) {
    return this.dataService.getRecordWithParams('/api/bulk/getUserDetailsBySPIdandCity', searchQuery);
  }
  getMessageList(searchQuery: string) {
    return this.dataService.getRecordWithParams('/api/bulk/getMessageList', searchQuery);
  }
  getPushMessageList(searchQuery: string) {
    return this.dataService.getRecordWithParams('/api/bulk/getPushMessageList', searchQuery);
  }

  getReminderMessageList(searchQuery: string) {
    return this.dataService.getRecordWithParams('/api/bulk/getReminderMessageList', searchQuery);
  }
  //getGentleRemainderViewList (searchQuery) {
  //    return this.dataService.getRecord('/api/bulk/getGentleRemainderViewList');
  //}
  getGentleRemainderViewList(searchQuery: string) {
    return this.dataService.getRecordWithParams('/api/bulk/getGentleRemainderViewList', searchQuery);
  }
}
